// extracted by css-extract-rspack-plugin
export default {"UpsellGem":"uWcaT","UpsellGemNew":"nQYXz"};